/* eslint-disable no-undef */
import { http } from '@/api'
import { Wechat } from '@/api/collection'
// import IconWechatLogo from '@/assets/pwc-logo.png'
// import { isWechat } from '@/util/detect'

export default async function initWechat(param) {
  const { debug = false, title, description, logo } = param

  const shareTitle = title || '普华永道YouPlus特训计划'
  const shareDescription = description || '秉承解决重要问题，营造社会诚信，普华永道推出面向年轻商务人群的培训项目，通过系统性的学习和针对性的实践，给予年轻商务人群，提供长远发展所需的知识、技能和工具，为个人发展创造多样化选择，驱动自我成长。'
  const shareLogo = logo || 'https://youplusapplicationtest.businesstrainingshpwc.com/application/img/wechat-logo.747f210a.png'

  const res = await http({
    path: Wechat.GetWxSignature.path,
    method: Wechat.GetWxSignature.method,
    data: {
      url: encodeURIComponent(`${location.origin}${location.pathname}${location.search}`),
      appId: 'wx8c354f53a71c0a2e'
    }
  })
  const { timestamp, appId, nonceStr, signature } = res.data || {}

  return new Promise((resolve, reject) => {
    wx.config({
      debug,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'chooseImage',
        'getLocalImgData',
        'hideMenuItems'
      ]
    })

    wx.ready(function() {
      wx.updateAppMessageShareData({
        title: shareTitle,
        desc: shareDescription,
        link: `${location.origin}${location.pathname}${location.hash}`,
        imgUrl: shareLogo,
        success: function() {
          console.info('updateAppMessageShareData success')
        }
      })
      wx.updateTimelineShareData({
        title: shareTitle,
        link: `${location.origin}${location.pathname}${location.hash}`,
        imgUrl: shareLogo,
        success: function() {
          console.info('updateTimelineShareData success')
        }
      })
      resolve()
    })

    wx.error(function(res) {
      console.error(res)
      reject(res)
    })
  })
}

// if (isWechat) {
//   if (process.env.NODE_ENV === 'production') {
//     initWechat()
//   } else {
//     initWechat({ debug: true })
//   }
// }
